<template>
  <div>
    <h1><img src="../assets/main.png" alt="TITLE" /></h1>
    <div class="white-area">
      <p class="thank">
        ENERYGY CHARGE LIVE(仮)<br />
        feat. ナオト・インティライミ
      </p>
      <div class="number-area number-area--another bold">
        <p class="area__title mb3 color-orange center">参加証</p>
        <div class="area__number--another mb6 center">
          <p>
            <small>受付番号</small><span id="tapCopy">{{ participantId }}</span>
          </p>
        </div>
        <p class="area__title area__title--second color-orange center">
          参加人数
        </p>
        <div class="people__number center">
          <p>{{ numberOfPeople }}<span>人</span></p>
        </div>
      </div>
      <p class="area__text--limlt--another bg-color1 center bold">
        現在の⽇時<br /><span id="nowDate"></span>
      </p>
      <p class="text--pass center bold">
        当⽇は受付にこの参加証をご提⽰ください。
      </p>
    </div>
    <div>
      <p class="title--black">イベント⽇時・場所</p>
      <div class="inner p3">
        <dl>
          <dt>●⽇時</dt>
          <dd>
            2020年4⽉7⽇（⽕）<br />
            開場 18:00<br />
            開演 19:00<br />
            終演 21:00（予定）
          </dd>
        </dl>
        <dl>
          <dt>●場所</dt>
          <dd>
            TSUTAYA O-WEST<br />
            東京都渋⾕区円⼭町2-3 2F<br />
            <a href="">公式ホームページ</a>
          </dd>
        </dl>
        <dl>
          <dt>●交通アクセス</dt>
          <dd>
            京王井の頭線「神泉駅」より徒歩3分<br />
            ⼭⼿線「渋⾕駅」ハチ公⼝より徒歩7分
          </dd>
        </dl>
      </div>
      <a class="event-link" href="">イベントの詳細はこちら</a>
    </div>
    <div>
      <p class="title--black">注意事項</p>
      <div class="inner p3 mb10">
        <p>
          ※イベント内容の録⾳・撮影等はお断りします。<br />
          ※会場までの交通費・宿泊費等は当選者さまのご負担となります。<br />
          ※当選賞品の転売や譲渡、換⾦はできません。<br />
          ※イベント当⽇の天候や出演者の都合等やむをえない事情により、中⽌または内容に変更がある場合があります。<br />
          ※18歳未満の⽅は、保護者の同意を得た上でご応募をお願いいたします。<br />
          ※10歳未満のお⼦様はご参加いただけません。10歳以上15歳未満のお⼦様のご参加の場合は、保護者の同伴が必要となります。<br />
          ※当⽇はスタッフがイベントの模様を録画・撮影いたします。これらの撮影物は「充レン」の各種PR・宣伝等のため弊社Webサイト、SNSや印刷物等に使⽤・掲載させていただくことがあります。予めご承諾願います。
        </p>
      </div>
    </div>

    <div class="coupon">
      <div class="bold">
        <p class="coupon__text--top center">
          ご応募いただいた⽅だけにスペシャルプレゼント
        </p>
        <p class="coupon__text--big color-orange center">
          モバイルバッテリーレンタルサービス<br />「充レン」<br /><strong
            >無料クーポン</strong
          >
        </p>
        <p class="coupon__text--middle">
          「充レン」を借りた⽇の翌⽇24時まで1回無料でご利⽤いただけます（税込330円相当）。
        </p>
      </div>
      <div class="number-area bold">
        <p class="area__title color-orange center">クーポン番号</p>
        <p
          class="area__number center"
          v-clipboard:copy="couponCode"
          v-clipboard:success="onCopy"
        >
          {{ couponCode }}
        </p>
        <p class="area__text--small color-orange center">
          番号をタップしてコピーできます。
        </p>
        <p class="area__text--midium">
          「充レン」をレンタルする際、レンタル情報確認画⾯で「クーポンを利⽤する」を選択して、クーポン番号を⼊⼒してください。
        </p>
        <p class="area__text--limlt bg-color1 center">
          クーポン有効期限:<br />2020年4⽉30⽇ 23時59分まで
        </p>
      </div>
      <p class="coupon__text--alert">
        ※1度ご利⽤いただいた後のクーポンは再利⽤できません<br />
        ※クーポンはご応募頂いたご本⼈様のみご利⽤可能です。第三者への譲渡はできません。<br />
        ※クーポンの現⾦化はできません。
      </p>
    </div>

    <footer>
      <div class="bg-black">
        <h3>お問い合わせ先</h3>
        <p class="footer__text--midium">《充レンサポートセンター》</p>
        <p class="footer__text--small">
          充レン公式LINEアカウントのメニューから、「Q&A・お問い合わせ」→「その他のお問い合わせ」→「トラブル等」を選択いただき、オペレーターをお呼び出しください。
        </p>
      </div>
      <div class="bg-gray">
        <p>(c) TEPCO Energy Partner, Inc.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      setIntervalId: null
    };
  },
  computed: {
    ...mapGetters(["participantId", "couponCode", "numberOfPeople"])
  },
  created() {
    this.setIntervalId = setInterval(() => this.setTime(), 1000);
  },
  destroyed() {
    clearInterval(this.setIntervalId);
  },
  methods: {
    setTime() {
      const target = document.getElementById("nowDate");
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = ("0" + date.getDate()).slice(-2);
      const hour = ("0" + date.getHours()).slice(-2);
      const min = ("0" + date.getMinutes()).slice(-2);
      const sec = ("0" + date.getSeconds()).slice(-2);
      target.innerHTML = `${year}年${month}月${day}日${hour}:${min}:${sec}`;
    },
    onCopy: () => {
      alert("コピーしました！");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Result.vue